import { logger } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { StoreWithSetter } from '../types';

type TagType = 'industry' | 'tag' | 'style' | 'symbol-type' | 'brand-values' | 'monogram';
type Tag = string;
interface TagData {
    tag: Tag;
    tagType: TagType;
}
type ProcessedTagData = ReturnType<typeof getProcessedTagData>;

const getProcessedTagData = (tagData: TagData) => {
    const { tag, tagType } = tagData;

    return {
        [MIXPANEL_EVENT_PROPERTIES.TAG_TYPE]: tagType,
        [MIXPANEL_EVENT_PROPERTIES.TAG]: tag,
    };
};

export class TagStore implements StoreWithSetter<TagData, ProcessedTagData | null> {
    private _tagData?: ProcessedTagData;

    private _rawData?: TagData;

    public setData = (tagData: TagData) => {
        this._tagData = getProcessedTagData(tagData);
    };

    public getRawData = () => this._rawData;

    public getData = () => {
        if (!this._tagData) {
            const error = new Error('Error in logo maker analytics. No tag data was set');
            logger.info(error);

            return null;
        }

        return this._tagData;
    };
}
